import { useState } from "react";
import { finishSeries, reopenSeries } from "../services/scriptService";
import { ScriptResponse } from "../types";

// FINISHED SERIES: "Mark series as finished" or "Reopen series", for scripts that belong to a series
const SeriesStatusButton = ({
  script,
  onChange,
}: {
  script: ScriptResponse;
  onChange?: () => void;
}) => {
  const [completed, setCompleted] = useState(!!script.seriesCompleted);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  if (!script.seriesId) return null;

  const handleClick = async () => {
    setSaving(true);
    setError("");
    try {
      if (completed) {
        await reopenSeries(script.seriesId!);
        setCompleted(false);
      } else {
        await finishSeries(script.seriesId!);
        setCompleted(true);
      }
      onChange?.();
    } catch (err: any) {
      setError(
        err.response?.data?.message ||
          "Could not update the series. Please try again.",
      );
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="bg-gray-900 rounded-xl p-4 border border-gray-700 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
      <div>
        <p className="text-gray-300 text-sm">
          {script.seriesTitle
            ? script.seriesTitle.replace(/\s*[–-]?\s*Part\s*\d+\s*$/i, "")
            : "This series"}
          {script.partNumber ? `, Part ${script.partNumber}` : ""}
        </p>
        <p className="text-gray-500 text-xs mt-1">
          {completed
            ? 'This series is finished, so it\'s hidden from "Continue a series".'
            : "This series is still open, so you can continue it from the Dashboard."}
        </p>
        {error && <p className="text-red-400 text-xs mt-1">{error}</p>}
      </div>
      <button
        onClick={handleClick}
        disabled={saving}
        className={`px-3 py-1 rounded-md text-xs transition whitespace-nowrap disabled:opacity-50 ${
          completed
            ? "bg-gray-700 hover:bg-gray-600 text-white"
            : "bg-green-600 hover:bg-green-700 text-white"
        }`}
      >
        {saving
          ? "Saving..."
          : completed
            ? "Reopen series"
            : "Mark series as finished"}
      </button>
    </div>
  );
};

export default SeriesStatusButton;
